import { useEffect, useRef, useCallback } from 'react';

const useScrambleText = (text) => {
  const elementRef = useRef(null);
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const intervalRef = useRef(null);
  const isAnimatingRef = useRef(false);

  const handleMouseOver = useCallback((event) => {
    // Prevent multiple simultaneous animations
    if (isAnimatingRef.current) return;
    
    isAnimatingRef.current = true;
    let iteration = 0;
    
    clearInterval(intervalRef.current);
    
    intervalRef.current = setInterval(() => {
      event.target.innerText = event.target.innerText
        .split("")
        .map((letter, index) => {
          if (index < iteration) {
            return event.target.dataset.value[index];
          }
          
          return letters[Math.floor(Math.random() * 26)];
        })
        .join("");
      
      if (iteration >= event.target.dataset.value.length) { 
        clearInterval(intervalRef.current);
        isAnimatingRef.current = false;
      }
      
      iteration += 1 / 2.5; // Slightly faster
    }, 25); // Reduced from 30ms to 25ms
  }, [letters]);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    // Set the data-value attribute
    element.dataset.value = text;

    element.addEventListener('mouseover', handleMouseOver);

    // Cleanup
    return () => {
      element.removeEventListener('mouseover', handleMouseOver);
      clearInterval(intervalRef.current);
      isAnimatingRef.current = false;
    };
  }, [text, handleMouseOver]);

  return elementRef;
};

export default useScrambleText;
